export default {"src":"/_next/static/media/glxt.fa974ad0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};